module.exports = __webpack_public_path__ + "static/media/portfolio1 (22).9c045780.jpeg";